import React from 'react';
import PropTypes from 'prop-types';
import { Anchor } from 'components/base';

import tracker from '../../lib/tracker';
import { VIEW_ON_WALL_APP_STORE_URL } from '../../lib/viewOnWall.mjs';

/**
 * "View on your wall" card in the Product details side column, promoting the
 * AR preview of the iOS app. Rendered only for isViewOnWallProduct products.
 */
const ViewOnWallCard = ({ productId }) => {
  const handleAppStoreClick = () => {
    tracker.onCustomEvent('view_on_wall_pdp_cta_click', {
      cta: 'app_store',
      location: 'badge',
      product_id: productId,
    });
  };

  return (
    <div className="pdp-wall">
      <div className="pdp-wall-head">
        <h3 className="pdp-block-title pdp-wall-title">View on your wall</h3>
        <span className="pdp-wall-microcopy">In the Parabo Press app</span>
      </div>
      <div className="pdp-wall-body">
        <div className="pdp-wall-phone" aria-hidden="true">
          <img
            src="/static/img/view-on-wall-preview.webp"
            alt=""
            width="102"
            height="200"
            loading="lazy"
          />
        </div>
        <div className="pdp-wall-text">
          <p className="pdp-wall-benefit">
            See your photo and crop on your own wall at real print size before you order, using
            augmented reality on a supported iPhone or iPad.
          </p>
          <div className="pdp-wall-cta">
            <Anchor
              className="pdp-wall-badge"
              href={VIEW_ON_WALL_APP_STORE_URL}
              targetBlank
              onClick={handleAppStoreClick}
            >
              <img
                src="/static/img/app-store-badge.svg"
                alt="Download Parabo Press on the App Store"
                width="120"
                height="40"
              />
            </Anchor>
            {/* Desktop handoff to the phone, same OneLink as the badge. */}
            <div className="pdp-wall-qr">
              <img
                src="/static/img/view-on-wall-qr.svg"
                alt="QR code for the Parabo Press app on the App Store"
                width="88"
                height="88"
                loading="lazy"
              />
              <span>
                Scan with
                <br />
                your iPhone
              </span>
            </div>
          </div>
        </div>
      </div>
      <p className="pdp-wall-privacy">
        The camera view is live only. Nothing is recorded, saved, or uploaded.
      </p>
    </div>
  );
};

ViewOnWallCard.propTypes = {
  productId: PropTypes.string.isRequired,
};

export default ViewOnWallCard;
